// regelfil: src/AGENTS.md
/**
 * Liten jämförelsestapel. Ämnet i primärgrönt (sidans ämne), jämförelsen i
 * dämpad ton (sammanhanget). Ingen färg, pil eller symbol betyder omdöme —
 * riktningen står i texten under. Talen står som text; staplarna är dolda
 * för skärmläsare eftersom de inte säger något mer.
 */
import { formateraTal, jamforText, stapelBredd, type Jamforelse } from "@/lib/jamforstapel";

export function JamforStapel({ j, className = "" }: { j: Jamforelse; className?: string }) {
  const t = (v: number) => formateraTal(v, j.matt.decimaler);
  const [a, b] = j.jamfor ? stapelBredd(j.amne.varde, j.jamfor.varde) : [100, 0];
  return (
    <figure className={`max-w-md rounded-card border border-line bg-surface p-4 ${className}`} data-jamforstapel>
      <figcaption className="text-small font-semibold text-ink">{j.matt.rubrik}</figcaption>
      <p className="sr-only">{jamforText(j)}</p>
      {j.jamfor ? (
        <div className="mt-3 space-y-2" aria-hidden="true">
          {[
            { etikett: j.amne.etikett, varde: j.amne.varde, bredd: a, cls: "bg-primary" },
            { etikett: j.jamfor.etikett, varde: j.jamfor.varde, bredd: b, cls: "bg-ink-muted" },
          ].map((r) => (
            <div key={r.etikett} className="grid grid-cols-[5.5rem_1fr_auto] items-center gap-2 text-small">
              <span className="text-ink-muted">{r.etikett}</span>
              <span className="h-3 rounded-pill bg-background">
                <span className={`block h-3 rounded-pill ${r.cls}`} style={{ width: `${r.bredd}%` }} />
              </span>
              <span className="tabular-nums font-semibold text-ink">{t(r.varde)}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-2 font-display text-h3 tabular-nums text-ink" aria-hidden="true">
          {t(j.amne.varde)} <span className="text-small font-normal text-ink-muted">{j.matt.enhet}</span>
        </p>
      )}
      <p className="mt-3 text-small text-ink-muted">
        {j.matt.riktning} {j.jamfor?.etikett === "Kommunen" ? `Kommunens snitt av ${j.jamfor.antal} enheter. ` : ""}
        {j.period}. Källa: {j.matt.kalla}.
      </p>
    </figure>
  );
}
